import React from "react";
import { IconProps } from "./IconProps";

const EquipmentCatalog: React.FC<IconProps> = ({
  size = 22,
  color = "#F7F9F9",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M9.84375 1.96875C9.84375 1.50117 9.46758 1.125 9 1.125C8.53242 1.125 8.15625 1.50117 8.15625 1.96875V2.70703L4.5 2.25C3.87773 2.25 3.375 2.75273 3.375 3.375C3.375 3.99727 3.87773 4.5 4.5 4.5L8.15625 4.04297V6.75H1.6875V6.46875C1.6875 6.00117 1.31133 5.625 0.84375 5.625C0.376172 5.625 0 6.00117 0 6.46875V7.59375V14.9062V16.0312C0 16.4988 0.376172 16.875 0.84375 16.875C1.31133 16.875 1.6875 16.4988 1.6875 16.0312V15.75H16.3125V16.0312C16.3125 16.4988 16.6887 16.875 17.1562 16.875C17.6238 16.875 18 16.4988 18 16.0312V14.9062V7.59375V6.46875C18 6.00117 17.6238 5.625 17.1562 5.625C16.6887 5.625 16.3125 6.00117 16.3125 6.46875V6.75H9.84375V4.04297L13.5 4.5C14.1223 4.5 14.625 3.99727 14.625 3.375C14.625 2.75273 14.1223 2.25 13.5 2.25L9.84375 2.70703V1.96875ZM1.6875 14.0625V8.4375H9H16.3125V14.0625H1.6875Z"
        fill="#FCFCFD"
      />
    </svg>
  );
};

export default EquipmentCatalog;
